"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const material_1 = require("@mui/material");
function FormInput({ label = '', name, type = 'text', value, error, onChange, onBlur, placeholder = '', style = {}, readOnly = false, endAdornment = null, customInputLabelProps = {}, }) {
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: !!error, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { label: label, name: name, type: type, fullWidth: true, required: true, margin: "normal", value: value, autoComplete: "new-password", error: !!error, onChange: onChange, onBlur: event => onBlur?.(event), placeholder: placeholder, style: style, sx: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'hsla(0, 0%, 85%, 1)' : 'inherit',
                    },
                    '& .MuiFormLabel-asterisk': {
                        display: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'none' : 'inline',
                    },
                }, slotProps: {
                    input: { endAdornment, readOnly },
                    htmlInput: {
                        'data-testid': name,
                    },
                    inputLabel: {
                        ...customInputLabelProps,
                        shrink: true,
                    },
                } }), error && Array.isArray(error)
                ? error.map((err, index) => ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { "data-testid": "error-message", style: {
                        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? {
                                marginLeft: '0px',
                                marginRight: '0px',
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'flex-start',
                            }
                            : {}),
                    }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", err] }, index)))
                : error && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { "data-testid": "error-message", style: {
                        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? {
                                marginLeft: '0px',
                                marginRight: '0px',
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'flex-start',
                            }
                            : {}),
                    }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", error] }))] }));
}
exports.default = FormInput;
